<template>
    <div>
        <div class="banner">
            <img src="/static/help/purchaseb.png">
        </div>
        <div class="registerbody">
            <div class="register">
            <div class="registertitle">
                <p class="registertitlec">填写表单与我们联系</p>
                <p class="registertitles">带<span>*</span>的部分为必填选项</p>
            </div>
            <div class="link-top"></div>
            
            <user-contact-us></user-contact-us>  

            </div>
        </div>
        
    </div>

</template>

<script>
import UserContactUs from '../../components/user/UserContactUs.vue'


export default {
  components: { UserContactUs},
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案",
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案",
        },
      ],
    };
  },
}
</script>

<style scoped>
    .registerbody{
        background-color: #f3f5f7;
        overflow: hidden;
    }
    .register{
        width: 928px;
        margin: 0 auto;
        margin-top: 70px;
    }
    .register .registertitle .registertitlec{
        font-size: 36px;
        color: #2655ae;
        margin-bottom: 13px;
    }
    .register .registertitle .registertitles{
        font-size: 18px;
        color: #999999;
        margin-bottom: 20px;
    }
    .register .registertitle .registertitles span{
        color: #ff1111;
       
    }
     .link-top {
            width: 99%;
            height: 1px;
            border-top: solid #f7d385 1px;
            margin: 0 auto;
            margin-bottom: 25px;
     }
     .banner{
        width: 100%;
     }
     .banner img{
        width: 100%;
     }

</style>


// WEBPACK FOOTER //
// src/views/help/purchase.vue